import { BaseResponseSchema, CreateTenantUserRequestSchema, CreateUserResponseSchema, GetTenantUsersRequestSchema, GetUserByIdResponseSchema, GetUsersResponseSchema, UpdateTenantUserRequestSchema, UpdateUserResponseSchema, UserIdParamSchema, } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/tenant/users.routes.ts`. */
export const tenantUsersContract = {
    list: {
        method: 'GET',
        path: '/tenant/users',
        query: GetTenantUsersRequestSchema,
        response: GetUsersResponseSchema,
        responseStyle: 'unwrap-data',
        queryLimitMax: 100,
        errorMessage: 'Failed to get users',
    },
    getById: {
        method: 'GET',
        path: '/tenant/users/:userId',
        pathParams: UserIdParamSchema,
        response: GetUserByIdResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get user',
    },
    create: {
        method: 'POST',
        path: '/tenant/users',
        body: CreateTenantUserRequestSchema,
        response: CreateUserResponseSchema,
        responseStyle: 'unwrap-data',
        timeoutMs: 30000,
        errorMessage: 'Failed to create user',
    },
    update: {
        method: 'PUT',
        path: '/tenant/users/:userId',
        pathParams: UserIdParamSchema,
        body: UpdateTenantUserRequestSchema,
        response: UpdateUserResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to update user',
    },
    delete: {
        method: 'DELETE',
        path: '/tenant/users/:userId',
        pathParams: UserIdParamSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to delete user',
    },
    resendInvitation: {
        method: 'POST',
        path: '/tenant/users/:userId/invite',
        pathParams: UserIdParamSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        timeoutMs: 30000,
        errorMessage: 'Failed to resend invitation',
    },
    resetPassword: {
        method: 'POST',
        path: '/tenant/users/:userId/reset-password',
        pathParams: UserIdParamSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        timeoutMs: 30000,
        errorMessage: 'Failed to reset password',
    },
};
//# sourceMappingURL=tenant-users.contract.js.map